import { AttributeDetailRenderer, Attributes } from '@leverege/ui-attributes';
export default class ResourceEnumDetailRenderer extends AttributeDetailRenderer {
  getLabelAndValue(object, cxt) {
    const attr = Attributes.getAttribute(this.name, object.type);
    const label = this.detail?.label?.name || attr?.displayName || this.name || '';
    const value = attr == null ? null : attr.get(object.data, cxt);
    let str = null;
    try {
      str = JSON.stringify(value);
    } catch (err) {
      // do nothing?
    }
    return [label, str];
  }
}